import { Col, Row } from 'react-bootstrap'
import useContainerContext from '../../containerContext'
import SearchBox from '../../searchBox'
import { FilterDateRange, FilterCompanies, FilterStatus } from '../../filter'

const Filter = ({ isScreenBiggerThanMD }) => {
	const {
		setState,
		state: {
			query,
			query: { filter },
		},
	} = useContainerContext()

	// Debounced free-text search (500ms, like the admin portal); a new term always starts from the first page
	const onSearch = value => {
		setState(prev => ({
			...prev,
			query: { ...prev.query, skip: 0, search: value },
		}))
	}

	const onFilter = filterData => {
		setState(prev => {
			return {
				...prev,
				query: {
					...query,
					filter: filterData,
				},
			}
		})
	}

	return (
		<div className='pt-4'>
			<Row className='mb-3'>
				<Col xs={12} md={6} lg={3}>
					<SearchBox
						autoComplete='off'
						onChangeMode
						delay={500}
						blurOnSearch={false}
						defaultValue={query.search}
						placeholder='Estimate #, VIN or Stock/RO'
						onChange={onSearch}
					/>
				</Col>
			</Row>
			<Row>
				{isScreenBiggerThanMD && (
					<>
						<Col md={3}>
							<FilterCompanies
								fluid
								className='light'
								size='medium'
								value={filter.vendor}
								onChange={vendor => {
									const filterData = { ...filter, vendor }
									onFilter(filterData)
								}}
							/>
						</Col>
						<Col md={3}>
							<FilterStatus
								fluid
								className='light'
								size='medium'
								value={filter.status}
								onChange={status => {
									const filterData = { ...filter, status }
									onFilter(filterData)
								}}
							/>
						</Col>
						<Col md={6}>
							<FilterDateRange
								fluid
								className='light'
								size='medium'
								value={filter.dateRange}
								onChange={({ startDate, endDate, value }) => {
									const filterData = {
										...filter,
										startDate,
										endDate,
										dateRange: value,
									}
									onFilter(filterData)
								}}
							/>
						</Col>
					</>
				)}
			</Row>
		</div>
	)
}
export default Filter
